import React, { memo, useState, useCallback } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import {
  PageIndicator,
  Pager,
  AutoHeightImage,
} from '@redlink/components/atoms';

export const ImagesContainer = memo(({ data }) => {
  const { styles } = useStyle();
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);

  const renderImageItem = useCallback(({ item: { url } }) => {
    return <AutoHeightImage style={styles.imageItem} uri={url} />;
  }, []);

  return (
    <View>
      <Pager
        overlap={0}
        space={0}
        containerPadding={0}
        renderItem={renderImageItem}
        data={data}
        selectedIndex={selectedImageIndex}
        pageChanged={(index) => setSelectedImageIndex(index)}
      />
      {data.length > 1 && (
        <View style={styles.imageIndicatorContainer}>
          <PageIndicator
            selectedIndex={selectedImageIndex}
            size={8}
            count={data.length}
          />
        </View>
      )}
    </View>
  );
});

const useStyle = createUseStyle(({ colors, size, contentWidth }) => ({
  imageItem: {
    width: contentWidth,
    height: contentWidth,
  },
  imageIndicatorContainer: {
    position: 'absolute',
    bottom: 7,
    left: 0,
    right: 0,
    alignItems: 'center',
  },
}));
